import styled from "@emotion/styled";
import { color } from "metabase/lib/colors";
export const ErrorMessage = styled.div`
  color: ${color("error")};
  margin-top: 0.5rem;
`;
